module.exports = __webpack_public_path__ + "img/why-bg.c6f6676d.png";